import React, { useEffect, useRef, lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { useGlobalContext } from "../contexts/GlobalContext";
import Content from "../components/Content";
import { useUserContext } from "../contexts/UserContext";
import Logo from "../components/Logo";
import { useThemeContext } from "../contexts/ThemeContext";
import { LogoutButton } from "../pages/user/logout";
import { TOKEN_KEY } from "../config/variables";

// Lazy-loaded components
const Sidebar = lazy(() => import("../components/Sidebar"));
const TopBar = lazy(() => import("../components/TopBar"));

const AppLayout = () => {
  const { showSideMenu, setshowSideMenu } = useGlobalContext();
  const { userData } = useUserContext();
  const { allowedModules } = useGlobalContext();
  const { theme } = useThemeContext();
  const menuRef = useRef();

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setshowSideMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
    // eslint-disable-next-line
  }, []);

  const isAuthenticatedLayout =
    window.location.pathname !== "/user/logout" && !!userData && !!sessionStorage.getItem(TOKEN_KEY);
  const hasConfiguredModules = allowedModules && allowedModules.length > 0;
  return (
    <div className="layout">
      {isAuthenticatedLayout && hasConfiguredModules && (
        <div className={`left ${showSideMenu ? "open" : ""}`} ref={menuRef}>
          <Suspense fallback={<div>Loading Sidebar...</div>}>
            <Sidebar />
          </Suspense>
        </div>
      )}
      <div className={`main ${isAuthenticatedLayout ? "light" : ""}`}>
        {isAuthenticatedLayout && hasConfiguredModules && (
          <Suspense fallback={<div>Loading TopBar...</div>}>
            <TopBar />
          </Suspense>
        )}

        {isAuthenticatedLayout ? (
          <Content>
            {!hasConfiguredModules ? (
              <div className="no-modules">
                <div className="mt-3 mb-3 text-center">
                  <Logo
                    className="logo"
                    src={theme?.logo}
                    style={{ maxWidth: "250px", objectFit: "contain" }}
                  />
                </div>
                <h2>No modules configured for your account!</h2>
                <p>
                  Please contact your administrator to configure the necessary
                  modules.
                </p>
                <div className="mt-3 mb-3 d-flex justify-content-center gap-2 flex-wrap">
                  <a href="/" className="btn btn-primary">
                    Refresh
                  </a>
                  <LogoutButton />
                </div>
                <p>
                  <small>
                    If you are seeing this message unexpectedly, please contact
                    support.
                  </small>
                </p>
              </div>
            ) : (
              <Outlet />
            )}
          </Content>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
};

export default AppLayout;
